import { Form, Input, Select, Modal, Switch } from "antd";
import { useEffect, useState } from "react";
import "../../../styles/teamMember.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  setVehicleModel,
  FETCH_ALL_VEHICLE_MODEL,
} from "../../../store/fleet-store/reducer";

const { Option } = Select;

const FormVehicleMakes = ({ vhMakes, setvhMakes }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { organisationId } = useSelector(({ auth }) => auth.user);

  const { detailMake, models } = useSelector(
    ({ fleets }) => fleets.fleetReducer
  );

  useEffect(() => {
    FETCH_ALL_VEHICLE_MODEL(organisationId).then((data) =>
      dispatch(setVehicleModel(data))
    );
  }, [organisationId]);

  const handleChange = (e) => {
    const value = e.target.value;
    setvhMakes({
      ...vhMakes,
      description: value,
    });
  };

  const handleChangeSelect = (value) => {
    setvhMakes({
      ...vhMakes,
      model: value,
    });
  };

  return (
    <Form
      labelAlign="left"
      form={form}
      requiredMark={false}
      labelCol={{ span: 5 }}
    >
      <Form.Item
        label="Description"
        name="description"
        rules={[{ required: true }]}
      >
        <Input onChange={handleChange} />
      </Form.Item>

      <Form.Item label="Vehicle Model" name="model">
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            optionA.children
              .toLowerCase()
              .localeCompare(optionB.children.toLowerCase())
          }
          onSelect={handleChangeSelect}
        >
          {models &&
            models.map((type) => {
              return (
                <Option key={type._id} value={type._id}>
                  {type.description}
                </Option>
              );
            })}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default FormVehicleMakes;
